<template>
    <main>
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
                <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">EXAMENES</a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false"></a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false"></a>
            </li>
        </ul>
        <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
            <indexExamenes  :idHistoria="idHistoria" :finalizada="finalizada" :idUsuario="idUsuario" :usuario="usuario" :id-tipo-historia="idTipoHistoria"></indexExamenes>
        </div>
        <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
          
        </div>
        <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
            
        </div>
        </div>
    
    </main>
    
</template>
<script>
import indexExamenes from "../base/baseReporteExamenesAdolescente/indexExamenes";
import {required} from "vuelidate/lib/validators";

export default {
    props: ['idHistoria','finalizada','idUsuario','usuario','idTipoHistoria'],
    components:{indexExamenes},
    data(){
        return {
            riesgo : '',
        }
    },
    validations(){
        return {
            riesgo : {required},
        }
    },
   methods: {
        async save(){

            this.$refs.indexRiesgoCardiovascular.validate();
            //this.$refs.complicacionesIdentificadas.validate();
            //this.$refs.examenPies.validate();
            //this.$nextTick(() => {this.$refs.complicacionesIdentificadas.$v.touch();});
            //this.$nextTick(() => {this.$refs.examenPies.$v.touch();});
        

            if (!this.$refs.indexRiesgoCardiovascular.$v.$invalid) this.riesgo = 'S';
            //if (!this.$refs.complicacionesIdentificadas.$v.$invalid) this.complicaciones = 'S';
            //if (!this.$refs.examenPies.$v.$invalid) this.examenPies = 'S';
            
            this.$v.$touch();

            if(this.$v.$invalid) return;

            await this.$refs.indexRiesgoCardiovascular.retornar();
           //this.$nextTick(async () =>  { await this.$refs.complicacionesIdentificadas.save();});
           // this.$nextTick(async ()=>{ await this.$refs.examenPies.save();});
            
        }
    }
}
</script>

